module.exports = __webpack_public_path__ + "img/fun.df08990e.png";